import styled from 'styled-components';
import { Field } from 'formik';

// Form, field, button, form group

export const Form = styled.form`
	width: 300px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Input = styled(Field)`
	font-size: 1rem;
	line-height: 1.5;
	height: 2.5em;
	padding: 0.5rem;
	height: 35px;
	/* border: ${(props) => props.border || '1px solid #ccc'}; */
	background-color: #fff;
	border: 1px solid transparent;
	border-color: #dbdbdb;
	border-radius: 4px;
	color: #363636;

	box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
	max-width: 100%;
	width: 100%;

	&:focus {
		outline: none;
		border-color: #3273dc;
		box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);
	}
`;

export const Button = styled.button`
	width: 300px;
	height: 35px;
	background-color: #5995ef;
	color: #fff;
	border-radius: 3px;
`;

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	color: #777;
	font-family: 'Raleway', sans-serif;
	font-size: 0.8em;
	margin: 1.5em 0;
	position: relative;
`;

// Text

export const Title = styled.h1`
	font-family: 'Raleway', sans-serif;
	font-weight: 600;
	color: #4d4d4d;
	font-size: 2.2em;
`;

export const Title2 = styled.h2`
	font-family: 'Raleway', sans-serif;
	font-weight: 300;
	color: #4d4d4d;
	font-size: 1.8em;
`;

export const Text = styled.p`
	font-family: 'Raleway', sans-serif;
	color: ${(props) => props.color || '#4d4d4d'};
`;

export const Label = styled.label`
	font-size: 1.125em;
	font-weight: 800;
	margin-bottom: 0.5em;
	display: block;
`;

// export const Label = styled.label`
// 	display: flex;
// 	flex-direction: column;
// 	color: #777;
// 	font-family: 'Raleway', sans-serif;
// 	font-size: 0.8em;
// 	margin: 0.5em 0;
// 	position: relative;
// `;
